export interface FAQ {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    id: 'faq-1',
    question: '91网页版入口的最新地址是什么？',
    answer: '91网页版入口的最新官方直达地址会定期更新。您可以通过以下方式获取最新地址：在浏览器中直接输入官方域名；在搜索引擎中搜索"91网页版入口"找到官方认证结果；关注本站首页，我们会实时更新最新入口信息。建议将正确地址加入浏览器收藏夹，方便下次快速访问。',
  },
  {
    id: 'faq-2',
    question: '91网页版无法打开怎么办？',
    answer: '如果遇到91网页版无法打开的情况，请依次尝试以下方法：1）清除浏览器缓存和Cookie后重新访问；2）刷新DNS缓存（Windows用户在命令提示符中执行ipconfig/flushdns）；3）更换浏览器或更新至最新版本；4）检查网络连接，尝试切换WiFi或使用移动数据；5）暂时关闭防火墙和安全软件。如果以上方法均无效，可能是服务器正在维护，请稍后再试。',
  },
  {
    id: 'faq-3',
    question: '91网页版需要下载安装吗？',
    answer: '不需要。91网页版的最大优势就是无需下载任何客户端软件，您只需要使用浏览器（如Chrome、Edge、Firefox等）打开91网页版入口地址即可直接使用。这样不仅节省设备存储空间，还能随时随地通过任何设备访问。',
  },
  {
    id: 'faq-4',
    question: '91网页版在手机上能用吗？',
    answer: '完全可以。91网页版已经针对移动端进行了全面适配，您可以在手机浏览器（如手机版Chrome、Safari）中打开入口地址，界面会自动适配手机屏幕。您还可以将网页添加到手机主屏幕，使用体验接近原生App。',
  },
  {
    id: 'faq-5',
    question: '91网页版和客户端App有什么区别？',
    answer: '91网页版和客户端App的核心功能基本一致。网页版的优势在于无需下载安装、不占存储空间、跨平台使用、自动更新；客户端App的优势在于启动更快、体验更流畅、支持推送通知和部分离线功能。您可以根据使用习惯选择，也可以两者配合使用。',
  },
  {
    id: 'faq-6',
    question: '91网页版登录需要什么信息？',
    answer: '登录91网页版需要您的注册手机号（或用户名）和密码。如果您开启了账号保护功能（如两步验证），登录时还需要输入短信验证码。如果您忘记了密码，可以在登录页面点击"忘记密码"通过绑定的手机号或邮箱重置密码。',
  },
  {
    id: 'faq-7',
    question: '如何确保访问的是官方91网页版？',
    answer: '为确保访问的是官方91网页版而非仿冒网站，请注意以下几点：核实网址是否为官方域名；检查浏览器地址栏是否有安全锁标志（HTTPS加密）；不要通过不明来源的链接访问；认准官方认证标识。本站提供的91网页版入口地址均为经过验证的官方渠道。',
  },
  {
    id: 'faq-8',
    question: '91网页版支持哪些浏览器？',
    answer: '91网页版支持所有主流现代浏览器，包括Google Chrome（推荐90以上版本）、Microsoft Edge（推荐90以上版本）、Mozilla Firefox（推荐88以上版本）、Apple Safari（推荐14以上版本）、Opera等。建议使用最新版本的浏览器以获得最佳体验。',
  },
];